import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Check } from 'lucide-react'
import { type Language, type User, getMe, updateLanguage } from '../api/client'
import { extractErrorMessage } from '../api/errors'

const LANGUAGES: Array<{ code: Language; label: string }> = [
  { code: 'am', label: 'Հայերեն' },
  { code: 'ru', label: 'Русский' },
  { code: 'en', label: 'English' },
]

export function Settings() {
  const { t, i18n } = useTranslation()
  const [user, setUser] = useState<User | null>(null)
  const [loading, setLoading] = useState(true)
  const [saving, setSaving] = useState<Language | null>(null)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    getMe()
      .then(setUser)
      .catch((err) => setError(extractErrorMessage(err)))
      .finally(() => setLoading(false))
  }, [])

  const handleSelect = async (lang: Language) => {
    if (!user || user.language === lang || saving) return
    setSaving(lang)
    setError(null)
    try {
      const updated = await updateLanguage(lang)
      setUser(updated)
      await i18n.changeLanguage(lang)
    } catch (err) {
      setError(extractErrorMessage(err))
    } finally {
      setSaving(null)
    }
  }

  if (loading) return <p className="screen__hint">{t('home.loading')}</p>

  return (
    <div className="screen">
      <h1 className="screen__title">{t('settings.title')}</h1>

      {error && <p className="screen__error">{error}</p>}

      <div className="card">
        <div className="card__label">{t('settings.language')}</div>
        {LANGUAGES.map(({ code, label }) => {
          const active = user?.language === code
          return (
            <button
              key={code}
              type="button"
              className={`row${active ? ' row--active' : ''}`}
              onClick={() => handleSelect(code)}
              disabled={saving !== null}
            >
              <span>{label}</span>
              {active && <Check size={18} />}
              {saving === code && <span className="row__spinner" />}
            </button>
          )
        })}
      </div>

      <div className="card">
        <div className="card__label">{t('settings.about')}</div>
        <div className="card__value">bayt v0.1.0</div>
        <div className="card__hint">{t('settings.about_hint')}</div>
      </div>
    </div>
  )
}
